export default __webpack_public_path__ + "static/media/lawyer.f9bd26d7.jpg";